import OrderTestItemStatusBadges from "@/components/OrderTestItemStatusBadges";
import { ConsumerReportOrderStatusBadge } from "@/components/reports/Badges";
import Group from "@/tpo/Group";

export default function ConsumerOrderTestItemStatusBadges({
  orderTestItem,
  badgeProps,
  ...props
}) {
  const isReportLineItem = orderTestItem?.hasUserReport != null;

  if (isReportLineItem) {
    return (
      <Group gap={10} alignItems="center" alignSelf="flex-start" flexWrap="wrap" {...props}>
        <ConsumerReportOrderStatusBadge isAvailable={orderTestItem.hasUserReport} />
      </Group>
    );
  }

  return (
    <OrderTestItemStatusBadges
      orderTestItem={orderTestItem}
      badgeProps={badgeProps}
      {...props}
    />
  );
}
